// Canada-specific driverMobile actions
// Uses caAcctServerInstance and Canada backend endpoints.
// Do NOT merge into driverMobileActions.js — that file is US-only.

import { caAcctServerInstance } from "../axios/instances";
import { setUserPreference } from "../utilities/common.js";
import {
  USER_LOGIN_MOBILE,
  USER_LOGIN_MOBILE_SUCCESS,
  USER_LOGIN_MOBILE_FAIL,
  GET_ORDER_AND_SALARY,
  GET_ORDER_AND_SALARY_SUCCESS,
  GET_ORDER_AND_SALARY_FAIL,
  GET_ORDER_AND_SALARY_DETAIL,
  GET_ORDER_AND_SALARY_DETAIL_SUCCESS,
  GET_ORDER_AND_SALARY_DETAIL_FAIL,
  GET_ORDER_AND_SALARY_EMAIL,
  GET_ORDER_AND_SALARY_EMAIL_SUCCESS,
  GET_ORDER_AND_SALARY_EMAIL_FAIL,
  GET_ORDER_AND_SALARY_DETAIL_LA,
  GET_ORDER_AND_SALARY_DETAIL_LA_SUCCESS,
  GET_ORDER_AND_SALARY_DETAIL_LA_FAIL,
  GET_SALARY_ZIP_COUNT,
  GET_SALARY_ZIP_COUNT_SUCCESS,
  GET_SALARY_ZIP_COUNT_FAIL,
  GET_TEAM_ORDER_AND_SALARY,
  GET_TEAM_ORDER_AND_SALARY_SUCCESS,
  GET_TEAM_ORDER_AND_SALARY_FAIL,
  GET_TEAM_ORDER_AND_SALARY_DETAIL,
  GET_TEAM_ORDER_AND_SALARY_DETAIL_SUCCESS,
  GET_TEAM_ORDER_AND_SALARY_DETAIL_FAIL,
  GET_TEAM_ORDER_AND_SALARY_EMAIL,
  GET_TEAM_ORDER_AND_SALARY_EMAIL_SUCCESS,
  GET_TEAM_ORDER_AND_SALARY_EMAIL_FAIL,
  GET_TEAM_SALARY_ZIP_COUNT,
  GET_TEAM_SALARY_ZIP_COUNT_SUCCESS,
  GET_TEAM_SALARY_ZIP_COUNT_FAIL,
} from "./typesMobile";

export function logInUserMobileCA(username, password) {
  return function (dispatch) {
    dispatch({ type: USER_LOGIN_MOBILE });
    return caAcctServerInstance
      .post(`/ca/login`, {
        username: username,
        password: password,
      })
      .then(({ data }) => {
        dispatch({
          type: USER_LOGIN_MOBILE_SUCCESS,
          payload: data.data,
        });
        setUserPreference(
          data.data.token,
          data.data.userinfo.level,
          data.data.userinfo.city_id,
          data.data.userinfo.username,
          data.data.userinfo.id
        );
        window.localStorage.setItem("driver_id", data.data.userinfo.id);
        caAcctServerInstance.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${data.data.token}`;
        return Promise.resolve(data.data);
      })
      .catch((error) => {
        dispatch({
          type: USER_LOGIN_MOBILE_FAIL,
          payload: error,
        });
        return Promise.reject(error);
      });
  };
}

export function getOrdersAndSalary(time1, time2) {
  return function (dispatch) {
    dispatch({ type: GET_ORDER_AND_SALARY });
    return caAcctServerInstance
      .get(`/ordersandsalary?time1=${time1}&time2=${time2}`)
      .then(({ data }) => {
        dispatch({
          type: GET_ORDER_AND_SALARY_SUCCESS,
          payload: data,
        });
        return Promise.resolve(data);
      })
      .catch((error) => {
        dispatch({
          type: GET_ORDER_AND_SALARY_FAIL,
          payload: error,
        });
        return Promise.reject(error);
      });
  };
}

export function getOrdersByDate(time1, time2) {
  return function (dispatch) {
    dispatch({ type: GET_ORDER_AND_SALARY_DETAIL });
    return caAcctServerInstance
      .get(`/ordersbydate?time1=${time1}&time2=${time2}`)
      .then(({ data }) => {
        dispatch({
          type: GET_ORDER_AND_SALARY_DETAIL_SUCCESS,
          payload: data.data,
        });
        return Promise.resolve(data.data);
      })
      .catch((error) => {
        dispatch({
          type: GET_ORDER_AND_SALARY_DETAIL_FAIL,
          payload: error,
        });
        return Promise.reject(error);
      });
  };
}

export function getOrdersAndSalaryEmail(email, save, time1, time2) {
  return function (dispatch) {
    dispatch({ type: GET_ORDER_AND_SALARY_EMAIL });
    return caAcctServerInstance
      .get(
        `/ordersandsalaryemail?email=${encodeURIComponent(email)}&saveemail=${save}&time1=${time1}&time2=${time2}`
      )
      .then(({ data }) => {
        dispatch({
          type: GET_ORDER_AND_SALARY_EMAIL_SUCCESS,
          payload: data,
        });
        return Promise.resolve(data);
      })
      .catch((error) => {
        dispatch({
          type: GET_ORDER_AND_SALARY_EMAIL_FAIL,
          payload: error,
        });
        return Promise.reject(error);
      });
  };
}

export function getOrdersByZip(time1, time2) {
  return function (dispatch) {
    dispatch({ type: GET_SALARY_ZIP_COUNT });
    return caAcctServerInstance
      .get(`/ordersbyzip?time1=${time1}&time2=${time2}`)
      .then(({ data }) => {
        dispatch({
          type: GET_SALARY_ZIP_COUNT_SUCCESS,
          payload: data.data,
        });
        return Promise.resolve(data.data);
      })
      .catch((error) => {
        dispatch({
          type: GET_SALARY_ZIP_COUNT_FAIL,
          payload: error,
        });
        return Promise.reject(error);
      });
  };
}

export function getOrdersByDateLA(time1, time2) {
  return function (dispatch) {
    dispatch({ type: GET_ORDER_AND_SALARY_DETAIL_LA });
    return caAcctServerInstance
      .get(`/getOrdersByDate_1?time1=${time1}&time2=${time2}`)
      .then(({ data }) => {
        dispatch({
          type: GET_ORDER_AND_SALARY_DETAIL_LA_SUCCESS,
          payload: data.data,
        });
        return Promise.resolve(data.data);
      })
      .catch((error) => {
        dispatch({
          type: GET_ORDER_AND_SALARY_DETAIL_LA_FAIL,
          payload: error,
        });
        return Promise.reject(error);
      });
  };
}

export function getTeamOrdersAndSalary(time1, time2) {
  return function (dispatch) {
    dispatch({ type: GET_TEAM_ORDER_AND_SALARY });
    return caAcctServerInstance
      .get(`/teamordersandsalary?time1=${time1}&time2=${time2}`)
      .then(({ data }) => {
        dispatch({
          type: GET_TEAM_ORDER_AND_SALARY_SUCCESS,
          payload: data,
        });
        return Promise.resolve(data);
      })
      .catch((error) => {
        dispatch({
          type: GET_TEAM_ORDER_AND_SALARY_FAIL,
          payload: error,
        });
        return Promise.reject(error);
      });
  };
}

export function getTeamOrdersByDate(time1, time2) {
  return function (dispatch) {
    dispatch({ type: GET_TEAM_ORDER_AND_SALARY_DETAIL });
    return caAcctServerInstance
      .get(`/teamordersbydate?time1=${time1}&time2=${time2}`)
      .then(({ data }) => {
        dispatch({
          type: GET_TEAM_ORDER_AND_SALARY_DETAIL_SUCCESS,
          payload: data.data,
        });
        return Promise.resolve(data.data);
      })
      .catch((error) => {
        dispatch({
          type: GET_TEAM_ORDER_AND_SALARY_DETAIL_FAIL,
          payload: error,
        });
        return Promise.reject(error);
      });
  };
}

export function getTeamOrdersByZip(time1, time2) {
  return function (dispatch) {
    dispatch({ type: GET_TEAM_SALARY_ZIP_COUNT });
    return caAcctServerInstance
      .get(`/teamordersbyzip?time1=${time1}&time2=${time2}`)
      .then(({ data }) => {
        dispatch({
          type: GET_TEAM_SALARY_ZIP_COUNT_SUCCESS,
          payload: data.data,
        });
        return Promise.resolve(data.data);
      })
      .catch((error) => {
        dispatch({
          type: GET_TEAM_SALARY_ZIP_COUNT_FAIL,
          payload: error,
        });
        return Promise.reject(error);
      });
  };
}

export function getTeamOrdersAndSalaryEmail(email, save, time1, time2) {
  return function (dispatch) {
    dispatch({ type: GET_TEAM_ORDER_AND_SALARY_EMAIL });
    return caAcctServerInstance
      .get(
        `/teamordersandsalaryemail?email=${encodeURIComponent(email)}&saveemail=${save}&time1=${time1}&time2=${time2}`
      )
      .then(({ data }) => {
        dispatch({
          type: GET_TEAM_ORDER_AND_SALARY_EMAIL_SUCCESS,
          payload: data,
        });
        return Promise.resolve(data);
      })
      .catch((error) => {
        dispatch({
          type: GET_TEAM_ORDER_AND_SALARY_EMAIL_FAIL,
          payload: error,
        });
        return Promise.reject(error);
      });
  };
}
